/**
 * Regla del Id de collector al darlo de alta desde Web Admin 2 (CP-409).
 *
 * La regla real es la de adminapi (UpsertCollectorRequest.ValidateCollectorId):
 * letras en cualquier caja, dígitos, ".", "-" y "_", de 1 a 40. El Id se guarda
 * tal cual se tipea: la clave de DynamoDB (PRODUCT#<id>) distingue mayúsculas y
 * el onboarding ya crea ids mixtos (VallecitosWater, testNico), así que acá no
 * se fuerza mayúsculas. Lo único que sí se evita es sumar un id que difiera de
 * uno existente sólo en la caja (en prd ya conviven Pago24/pago24, Panino/panino…).
 */
export const COLLECTOR_ID_RE = /^[A-Za-z0-9._-]{1,40}$/;

export const COLLECTOR_ID_RULE =
  "Letters (case is kept), digits, . - or _ (1–40) · used in URLs and integrations, cannot be changed later.";

/** Id existente que coincide con `id` ignorando la caja (o undefined si no hay). */
export function findCaseCollision(id: string, existingIds: readonly string[]): string | undefined {
  const upper = id.toUpperCase();
  return existingIds.find((x) => x.toUpperCase() === upper);
}

export interface CollectorIdCheck {
  /** Id normalizado (sólo trim: la caja se preserva). */
  id: string;
  ok: boolean;
  help: string;
}

export function checkCollectorId(raw: string, existingIds: readonly string[]): CollectorIdCheck {
  const id = raw.trim();
  if (!id) return { id, ok: false, help: COLLECTOR_ID_RULE };
  if (!COLLECTOR_ID_RE.test(id)) return { id, ok: false, help: "Only letters, digits, . - and _ (1–40 chars)." };
  const twin = findCaseCollision(id, existingIds);
  if (twin !== undefined) {
    const help = twin === id ? `“${id}” already exists.` : `“${id}” already exists as “${twin}” (ids that differ only in letter case are not allowed).`;
    return { id, ok: false, help };
  }
  return { id, ok: true, help: COLLECTOR_ID_RULE };
}
